import { Map } from './components';
import { useMarkers } from './App.utils';

export default function App() {
  const markers = useMarkers();
  return <Map markers={markers} />;
}
